import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGardeningLawnMower = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "gardening-lawn-mower" }),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 15.75,
			y1: 13.5,
			x2: 15.75,
			y2: 16.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 9.75,
			y1: 16.5,
			x2: 9.75,
			y2: 13.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M10.25,9h5a2,2,0,0,1,2,2v2.5a0,0,0,0,1,0,0h-9a0,0,0,0,1,0,0V11A2,2,0,0,1,10.25,9Z"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-1",
			points: "5.983 17.499 3 1.5 0.75 1.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M19.976,18.247A3,3,0,0,0,17.25,16.5H9a3,3,0,0,0-2.625,1.548"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 6.348,
			y1: 21,
			x2: 18.879,
			y2: 21
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 21,
			cy: 20.25,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 3.75,
			cy: 19.5,
			r: 3
		})
	]
});
export default SvgGardeningLawnMower;
